import React from 'react';
import FileDocumentIcon from 'mdi-react/FileDocumentIcon';
import HomeIcon from 'mdi-react/HomeIcon';
import AccountIcon from 'mdi-react/AccountIcon';
import MonitorCellphoneIcon from 'mdi-react/MonitorCellphoneIcon';
import {
  CalendarOutlined,
  BellFilled,
  ProfileFilled,
  DollarCircleFilled,
  BarcodeOutlined,
  FileDoneOutlined,
} from '@ant-design/icons';
import {
  getUserPermissions,
} from '../../utils/users';

const menuItens = [
  {
    name: 'Início',
    visibility: ['COOPERCITRUS', 'COOPERATIVE'],
    permissions: ['basico'],
    icon: <HomeIcon />,
    subMenu: [],
    url: '/home',
    headerTitle: '',
    documentTitle: 'Home',
    standalone: true,
  },
  {
    name: 'Serviços',
    visibility: ['COOPERCITRUS', 'COOPERATIVE'],
    icon: <FileDocumentIcon />,

    permissions: [
      'Solicitar novo serviço',
      'Visualizar serviços solicitados',
      'Controlar serviços solicitados',
      'Importar shapefiles',
    ],

    subMenu: [
      {
        name: 'Novo serviço',
        visibility: ['COOPERCITRUS'],
        url: '/service/new',
        headerTitle: '',
        documentTitle: 'Novo Serviço',
        permissions: ['Solicitar novo serviço'],
      },
      {
        name: 'Novo serviço',
        visibility: ['COOPERATIVE'],
        url: '/service/new',
        headerTitle: '',
        documentTitle: 'Novo Serviço',
        permissions: ['Solicitar novo serviço', 'Solicitar novo orçamento'],
      },
      {
        name: 'Serviços solicitados',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        url: '/service/list',
        headerTitle: '',
        documentTitle: 'Serviços Solicitados',

        permissions: [
          'Visualizar serviços solicitados',
          'Controlar serviços solicitados',
        ],
      },
      {
        name: 'Orçamentos solicitados',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        url: '/service/estimates',
        headerTitle: '',
        documentTitle: 'Orçamentos Solicitados',

        permissions: [
          'Visualizar orçamentos solicitados',
          'Controlar orçamentos solicitados',
        ],
      },
      {
        name: 'Importar talhões',
        visibility: ['COOPERCITRUS'],
        url: '/service/shapefiles/import',
        headerTitle: '',
        documentTitle: 'Importar shapefiles',
        permissions: ['Importar shapefiles'],
      },
      {
        name: 'Resultados',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        url: '/service/results/results',
        headerTitle: '',
        documentTitle: 'Resultados',

        checkPermissionExpressionMethod: (): boolean => {
          const userPermissions = getUserPermissions();

          if (
            userPermissions.includes('Listagem de importação de resultados')
            && (
              userPermissions.includes('Solicitar novo orçamento')
              || userPermissions.includes('Solicitar novo serviço')
            )
          ) {
            return true;
          }

          return false;
        },
      },
    ],
  },
  {
    name: 'Usuários',
    visibility: ['COOPERCITRUS'],
    icon: <AccountIcon />,
    permissions: ['Cadastro de usuários', 'Perfis de usuário'],

    subMenu: [
      {
        name: 'Cadastro',
        visibility: ['COOPERCITRUS'],
        permissions: ['Cadastro de usuários'],
        headerTitle: '',
        documentTitle: 'Cadastro',
        url: '/user/list',
      },
      {
        name: 'Perfis',
        visibility: ['COOPERCITRUS'],
        permissions: ['Perfis de usuário'],
        url: '/roles/list',
        documentTitle: 'Perfis',
        headerTitle: '',
      },
    ],
  },
  {
    name: 'Sistema',
    visibility: ['COOPERCITRUS'],
    icon: <MonitorCellphoneIcon />,
    permissions: [
      'Parâmetros do sistema',
      'Relatório de logs do sistema',
      'Cadastro de Modelos de Equipamento',
      'Visualizar filiais solicitados',
      'Cadastro de Exercício/Ano Base - Informe de Rendimentos',
      'Cadastro de nota fiscal de serviço',
    ],

    subMenu: [
      {
        name: 'Parâmetros do sistema',
        visibility: ['COOPERCITRUS'],
        url: '/system/parameters',
        headerTitle: '',
        documentTitle: 'Parâmetros do sistema',
        permissions: ['Parâmetros do sistema'],
      },
      {
        name: 'Relatório de logs',
        visibility: ['COOPERCITRUS'],
        url: '/system/logs',
        headerTitle: '',
        documentTitle: 'Relatório de logs',
        permissions: ['Relatório de logs do sistema'],
      },
      {
        name: 'Modelos de equipamento',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        url: '/system/equipamentModel',
        headerTitle: '',
        documentTitle: 'Cadastro de Modelos de Equipamento',
        permissions: ['basico'],
      },
      {
        name: 'Filiais',
        visibility: ['COOPERCITRUS'],
        url: '/system/branches',
        headerTitle: '',
        documentTitle: 'Cadastro de Filiais',
        permissions: ['Visualizar filiais solicitados'],
      },
      {
        name: 'Cadastro de Exercício/Ano Base',
        visibility: ['COOPERCITRUS'],
        url: '/base-year-exercises',
        headerTitle: '',
        documentTitle: 'Cadastro de Filiais',
        permissions: ['Cadastro de Exercício/Ano Base - Informe de Rendimentos'],
      },
      {
        name: 'Cadastro de Notas Fiscais de Serviço',
        visibility: ['COOPERCITRUS'],
        url: '/service-invoice',
        headerTitle: '',
        documentTitle: 'Cadastro de Notas Fiscais de Serviço',
        permissions: ['Cadastro de nota fiscal de serviço'],
      },
    ],
  }, /*
  {
    name: 'Programa de fidelidade',
    visibility: ['COOPERCITRUS', 'COOPERATIVE'],
    permissions: [
      'Simulador de aquisição',
      'Conversão de crédito por serviço (escrita)',
      'Saldo de créditos'
    ],
    icon: <GiftIcon />,

    subMenu: [
      {
        url: '/fidelity/credit',
        documentTitle: 'Conversão de créditos',
        name: 'Conversão de créditos',
        visibility: ['COOPERCITRUS'],
        permissions: ['Conversão de crédito por serviço (escrita)'],
      },
      {
        url: '/fidelity/creditbalance',
        documentTitle: 'Saldo de Créditos',
        name: 'Saldo de Créditos',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        permissions: ['Saldo de créditos'],
      },
      {
        url: '/fidelity/simulator',
        documentTitle: 'Simulador de Aquisição',
        name: 'Simulador de Aquisição',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        permissions: ['Simulador de aquisição'],
      },
    ],
  }, */
  // {
  //   name: 'Financeiro',
  //   visibility: ['COOPERCITRUS', 'COOPERATIVE'],
  //   permissions: ['Contas a pagar', 'Contas a receber'],
  //   icon: (<CurrencyUsdIcon />),

  //   subMenu: [
  //     {
  //       name: 'Contas a pagar',
  //       visibility: ['COOPERCITRUS', 'COOPERATIVE'],
  //       url: '/financial/payables',
  //       headerTitle: '',
  //       documentTitle: 'Contas a pagar',
  //       permissions: ['Contas a pagar'],
  //     },
  //     {
  //       name: 'Contas a receber',
  //       visibility: ['COOPERCITRUS', 'COOPERATIVE'],
  //       url: '/financial/receivables',
  //       headerTitle: '',
  //       documentTitle: 'Contas a receber',
  //       permissions: ['Contas a receber'],
  //     },
  //   ],
  // },
  {
    name: 'Eventos',
    visibility: ['COOPERCITRUS', 'COOPERATIVE'],
    icon: <CalendarOutlined />,
    permissions: ['basico'],

    subMenu: [
      {
        name: 'Calendário',
        visibility: ['COOPERCITRUS', 'COOPERATIVE'],
        permissions: ['basico'],
        headerTitle: '',
        documentTitle: 'Calendário',
        url: '/events',
      },
    ],
  },
  {
    name: 'Notificações',
    visibility: ['COOPERCITRUS'],
    icon: <BellFilled />,
    permissions: ['Listagem de categoria', 'Visualizar notificações'],

    subMenu: [
      {
        name: 'Categorias',
        visibility: ['COOPERCITRUS'],
        permissions: ['Listagem de categoria'],
        headerTitle: '',
        documentTitle: 'Categorias',
        url: '/notificationcategories',
      },
      {
        name: 'Cadastro',
        visibility: ['COOPERCITRUS'],
        url: '/system/notifications',
        headerTitle: '',
        documentTitle: 'Gerenciamento de Notificações',
        permissions: ['Visualizar notificações'],
      },
    ],
  },
  {
    name: 'Hidden',
    visibility: [],
    icon: null,

    subMenu: [
      {
        name: '',
        visibility: [],
        url: '/notifications',
        headerTitle: 'Notificações',
        documentTitle: 'Notificações',
      },
      {
        name: '',
        visibility: [],
        url: '/change-password',
        headerTitle: '',
        documentTitle: 'Alterar senha',
      },
      {
        name: '',
        visibility: [],
        url: '/service/detail',
        headerTitle: '',
        documentTitle: 'Detalhes do serviço',
      },
      {
        name: '',
        visibility: [],
        url: '/service/status',
        headerTitle: '',
        documentTitle: 'Status da solicitação',
      },
      {
        name: '',
        visibility: [],
        url: '/notification',
        headerTitle: 'Notificações',
        documentTitle: 'Notificações',
      },
    ],
  },
  /* {
    visibility: [],
    permissions: ['Cadastro de usuários'],
    subMenu: [],
    url: '/user/register',
    headerTitle: '',
    standalone: true,
  }, */
  {
    visibility: [],
    permissions: ['Cadastro de usuários'],
    subMenu: [],
    url: '/user/edit',
    headerTitle: '',
    documentTitle: 'Editar usuário',
    standalone: true,
  },
  {
    visibility: [],
    permissions: ['Cadastro de usuários'],
    subMenu: [],
    url: '/profile/create',
    standalone: true,
  },
  {
    name: 'Solicitações de exclusão de conta',
    visibility: ['COOPERCITRUS'],
    icon: <ProfileFilled />,
    permissions: ['Solicitações de exclusão de conta'],
    url: '/account-deletion-requests',
    subMenu: [],
    documentTitle: 'Solicitações de exclusão de conta',
    standalone: true,
  },
  {
    name: 'Boletos',
    visibility: ['COOPERATIVE'],
    icon: <BarcodeOutlined />,
    permissions: ['Download de Boletos'],
    url: '/bank-payment-slip',
    subMenu: [],
    documentTitle: 'Boletos',
    standalone: true,
  },
  {
    name: 'Informe de Rendimentos',
    visibility: ['COOPERATIVE'],
    icon: <DollarCircleFilled />,
    permissions: ['Download de IR'],
    url: '/report-income',
    subMenu: [],
    documentTitle: 'Informe de Rendimentos',
    standalone: true,
  },
  {
    name: 'Nota Fiscal',
    visibility: ['COOPERATIVE'],
    icon: <FileDoneOutlined />,
    permissions: ['Download de nota fiscal'],
    url: '/download-nf',
    subMenu: [],
    documentTitle: 'Nota Fiscal',
    standalone: true,
  },
];

export {
  menuItens,
};
